// Commitment-length pricing tiers on a subscription plan, or on a one-off `service` that also
// offers "subscribe and save" (service_config.subscription_tiers on Product — see
// backend/shop/logic/service_pricing.py for the authoritative shape/validation).

export const RENEWAL_POLICIES = ['auto_renew_same_tier', 'revert_to_base', 'require_manual_renewal'] as const;
export type RenewalPolicy = typeof RENEWAL_POLICIES[number];

export const MAX_TIER_MONTHS = 12;

export interface SubscriptionTier {
    id: string;
    label: string;
    months: number;
    monthly_price: number;
    allow_monthly_billing: boolean;
    allow_upfront_billing: boolean;
    renewal_policy: RenewalPolicy;
    is_active?: boolean;
    stripe_price_id_monthly?: string | null;
    stripe_price_id_upfront?: string | null;
}

/** Mirrors shop/logic/service_pricing.py:active_subscription_tiers — same filtering rules, so the
 * storefront never offers a tier the backend would reject at checkout (missing price sync, no
 * billing mode enabled, soft-deleted, or an out-of-range commitment length). */
export function activeSubscriptionTiers(serviceConfig: any): SubscriptionTier[] {
    const tiers = serviceConfig?.subscription_tiers;
    if (!Array.isArray(tiers)) return [];
    return tiers.filter((t: any): t is SubscriptionTier =>
        t && typeof t === 'object'
        && t.is_active !== false
        && typeof t.id === 'string' && t.id.length > 0
        && Number.isInteger(t.months) && t.months >= 1 && t.months <= MAX_TIER_MONTHS
        && typeof t.monthly_price === 'number' && t.monthly_price >= 0
        && (t.allow_monthly_billing !== false || t.allow_upfront_billing === true),
    );
}
